'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _paths = require('./paths');

var _paths2 = _interopRequireDefault(_paths);

var _config = require('config');

var _getApiPath = require('./getApiPath');

var _getApiPath2 = _interopRequireDefault(_getApiPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = new _map2.default();

function formatUrl(path) {
  var adjustedPath = path.split('/').filter(function (el) {
    return el;
  }).join('/');

  if (!_config.CLIENT) {
    var _url = (0, _getApiPath2.default)(adjustedPath);
    console.log('Query the Craft API directly, this is server side rendering', _url);
    return _url;
  }

  var url = '/api' + (0, _getApiPath.getAdjustedPath)(adjustedPath);
  console.log('this is the client, query proxied api', url);
  return url;
}

var getPaths = function getPaths(type) {
  return _paths2.default[type];
};

var getUrl = function getUrl(type) {
  if (_paths2.default[type]) {
    var path = getPaths(type);
    return formatUrl(path);
  }

  return formatUrl(type);
};

// sometimes the response from the server comes back incorrectly
// encoded; if so, we can do some fancy footwork here
// to get it into a useable state.
var parseJSONResponse = function parseJSONResponse(response) {
  return response.json();
};

var Api = {
  fetch: function fetch(type) {
    var url = getUrl(type);
    return function () {
      if (_config.ENABLE_API_CACHING && cache.get(type)) {
        return _promise2.default.resolve(cache.get(type));
      }

      //console.log('Api fetch:', type, url);
      return (0, _isomorphicFetch2.default)(url, { method: 'get' }).then(function (response) {
        //console.log('Api got response back for', type);
        if (response.status >= 400) {
          throw new Error(response);
        }

        return response;
      }).then(parseJSONResponse).then(function (response) {
        cache.set(type, response);
        return response;
      }).catch(function () {
        throw new Error('Invalid JSON from API: ' + url);
      });
    };
  }
};

exports.default = Api;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/utils/Api/index.js
// module id = 278
// module chunks = 0